import { Equipments, STATUSES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const equipmentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMerchantEquipment: build.query({
      query: (params = {}) => ({
        url: Equipments.GETEQUIPMENTDBA(),
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('Equipment', result),
    }),
    getEquipmentById: build.query({
      query: (id) => ({ url: Equipments.BY_ID(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'Equipment', id }],
    }),
    getEquipmentStatuses: build.query({
      query: () => ({
        url: STATUSES.LIST,
        method: 'GET',
        params: { 'conditions[model]': 'Equipment' },
      }),
      providesTags: [{ type: 'Status', id: 'EQUIPMENT' }],
    }),
    createEquipment: build.mutation({
      query: (payload) => ({
        url: Equipments.LIST,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: [{ type: 'Equipment', id: 'LIST' }],
    }),
    getEquipmentLogs: build.query({
      query: (equipmentId) => ({
        url: Equipments.EQUIPMENT_LOGS(equipmentId),
        method: 'GET',
      }),
      providesTags: (_r, _e, id) => [{ type: 'Equipment', id: `logs-${id}` }],
    }),
    deleteEquipment: build.mutation({
      query: (equipmentId) => ({
        url: Equipments.BY_ID(equipmentId),
        method: 'DELETE',
      }),
      invalidatesTags: (_r, _e, equipmentId) => [
        { type: 'Equipment', id: equipmentId },
        { type: 'Equipment', id: 'LIST' },
      ],
    }),
    updateEquipmentStatus: build.mutation({
      query: ({ equipmentId, payload }) => ({
        url: Equipments.STATUS(equipmentId),
        method: 'PUT',
        data: payload,
      }),
      invalidatesTags: (_r, _e, { equipmentId }) => [
        { type: 'Equipment', id: equipmentId },
        { type: 'Equipment', id: 'LIST' },
        { type: 'Equipment', id: `logs-${equipmentId}` },
      ],
    }),
  }),
});

export const {
  useGetMerchantEquipmentQuery,
  useLazyGetMerchantEquipmentQuery,
  useGetEquipmentByIdQuery,
  useLazyGetEquipmentByIdQuery,
  useGetEquipmentStatusesQuery,
  useLazyGetEquipmentStatusesQuery,
  useCreateEquipmentMutation,
  useGetEquipmentLogsQuery,
  useLazyGetEquipmentLogsQuery,
  useDeleteEquipmentMutation,
  useUpdateEquipmentStatusMutation,
} = equipmentApi;
